import 'htmx.org';
import './file_input_toggle.js';
import './global_htmx.js';
import './htmx_error.js';
import './location.js';
import './modal.js';
import './stars.js';